/**
 * Stack routes of the native screens added by the `crm` admin-module group.
 * Registered by AppNavigator in the management stack.
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    {name: 'CrmListScreen', component: lazyScreen(() => import('../../screens/adminModules/crm/CrmListScreen'))},
    {name: 'CrmRecordScreen', component: lazyScreen(() => import('../../screens/adminModules/crm/CrmRecordScreen'))},
    {name: 'CrmConfigScreen', component: lazyScreen(() => import('../../screens/adminModules/crm/CrmConfigScreen'))},
    {name: 'CrmStatsScreen', component: lazyScreen(() => import('../../screens/adminModules/crm/CrmStatsScreen'))},
    {name: 'CrmSearchScreen', component: lazyScreen(() => import('../../screens/adminModules/crm/CrmSearchScreen'))},
    {name: 'CrmCallCenterScreen', component: lazyScreen(() => import('../../screens/adminModules/crm/CrmCallCenterScreen'))},
    {name: 'CrmComplaintCreateScreen', component: lazyScreen(() => import('../../screens/adminModules/crm/CrmComplaintCreateScreen'))},
];

export default ROUTES;
